import { ICaminhaoRepository } from '../repositories/ICaminhaoRepository'

export interface IDeleteCaminhao {
  execute(id: number): Promise<void>
}

export default class DeleteCaminhaoImpl implements IDeleteCaminhao {
  constructor(private readonly caminhaoRepository: ICaminhaoRepository) {}

  public async execute(id: number): Promise<void> {
    await this.caminhaoRepository.delete(id)
  }
}
